import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'CareerAiHeader',
  props: {
  // 応答待ちのあいだは新規チャットを押させない
  loading: {
    type: Boolean,
    default: false
  }
},
  emits: ['expand', 'clear', 'close'],
  setup(__props) {




return { __sfc: true, }
}

})